import { AdapterFactory } from '../AdapterFactory';

export const workOrderService = AdapterFactory.getWorkOrderAdapter();
